//PARROQUIAS Amazonas
const munAltoOrinico = [
  'La Esmeralda​',
  'Huachamacare​',
  'Marawaka​',
  'Mavaka​',
  'Sierra Parima​',
];
const munAtabapo = ['Atabapo', 'Ucata​', 'Yapacana​', 'Caname'];
const munAtures = [
  'Fernando Girón Tovar',
  'Luis Alberto Gómez',
  'Pahueña',
  'Platanillal',
];
const munAutana = [
  'Samariapo​',
  'Sipapo',
  'Munduapo​',
  'Guayapo​',
  'Isla Ratón',
];
const munManapiare = [
  'Alto Ventuari​',
  'Medio Ventuari​',
  'Bajo Ventuari​',
  'Manapiare',
];
const munMaroa = ['Maroa', 'Victorino​', 'Comunidad​'];

const munRioNegro = [
  'Casiquiare, Curimacare​',
  'Cocuy​',
  'San Carlos de Río Negro, San Carlos de Río Negro ​',
  'Solano, Solano​',
];
export const esAmazonas = [
  {
    municipio: 'Alto Orinoco',
    parroquias: munAltoOrinico,
  },
  {
    municipio: 'Atabapo',
    parroquias: munAtabapo,
  },
  {
    municipio: 'Atures',
    parroquias: munAtures,
  },
  {
    municipio: 'Autana',
    parroquias: munAutana,
  },
  {
    municipio: 'Manapiare',
    parroquias: munManapiare,
  },
  {
    municipio: 'Maroa',
    parroquias: munMaroa,
  },
  {
    municipio: 'Río Negro',
    parroquias: munRioNegro,
  },
];
